import { TSLandingPage } from "../components/TSLandingPage";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { FullScreenPerformanceMetrics } from "../pages/demos/chm/FullScreenPerformanceMetrics";
import { HeatmapPerformanceMetrics } from "../pages/demos/chm/HeatmapPerformanceMetrics";
import { TablePerformanceMetrics } from "../pages/demos/chm/TablePerformanceMetrics";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import {
  GenerateSidebar,
  SubdomainOrgIdObject,
} from "./FunctionsAndInterfaces";

const orgId: number = 74610152;
const subDomain: string = "cambio";
const nameOfProduct: string = "Cambio";
const secureRouteGroups: string[] = ["CHM"];

export const chmObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  externalInfo: { subdomain: "chm", productURL: "chm" },
};

export const loanOfficerUsers = [
  "chm_abmorales@changemtg.com",
  "chm_awisner@changemtg.com",
  "chm_ayork@changemtg.com",
  "chm_aparrish@changemtg.com",
  "chm_acalderon@changemtg.com",
  "chm_aromero@changemtg.com",
  "chm_bburnett@changemtg.com",
  "chm_bixta@changemtg.com",
  "chm_bhenly@changemtg.com",
  "chm_bcrowder@changemtg.com",
  "chm_bmartinez@changemtg.com",
  "chm_tteam@changemtg.com",
  "chm_csaldana@changemtg.com",
  "chm_chernandez@changemtg.com",
  "chm_chrodriguez@changemtg.com",
  "chm_clowary@changemtg.com",
  "chm_cvisalda@changemtg.com",
  "chm_cbosse@changemtg.com",
  "chm_cbacon@changemtg.com",
  "chm_darice@changemtg.com",
  "chm_deghbali@changemtg.com",
  "chm_dvasquez@changemtg.com",
  "chm_dlangston@changemtg.com",
  "chm_dpatedoscher@changemtg.com",
  "chm_dslotkin@changemtg.com",
  "chm_dchildres@changemtg.com",
  "chm_dchristiana@changemtg.com",
  "chm_dkeshish@changemtg.com",
  "chm_eflores@changemtg.com",
  "chm_ecastillo@changemtg.com",
  "chm_eweinberger@changemtg.com",
  "chm_eruiz@changemtg.com",
  "chm_ecouncil@changemtg.com",
  "chm_fgist@changemtg.com",
  "chm_gsnowden@changemtg.com",
  "chm_gdrake@changemtg.com",
  "chm_gyanez@changemtg.com",
  "chm_gparra@changemtg.com",
  "chm_hquinlan@changemtg.com",
  "chm_ilazo@changemtg.com",
  "chm_ialvidrez@changemtg.com",
  "chm_jro@changemtg.com",
  "chm_jbecker@changemtg.com",
  "chm_jleong@changemtg.com",
  "chm_jsauceda@changemtg.com",
  "chm_jdecastro@changemtg.com",
  "chm_jacevedo@changemtg.com",
  "chm_jliang@changemtg.com",
  "chm_jbrooks@changemtg.com",
  "chm_jmikhail@changemtg.com",
  "chm_joslynm@changemtg.com",
  "chm_jsmith@changemtg.com",
  "chm_jcortez@changemtg.com",
  "chm_kmanuel@changemtg.com",
  "chm_ksteele@changemtg.com",
  "chm_kgaldamez@changemtg.com",
  "chm_kstypula@changemtg.com",
  "chm_kparrett@changemtg.com",
  "chm_kmirza@changemtg.com",
  "chm_kbreen@changemtg.com",
  "chm_lyasamifar@changemtg.com",
  "chm_loropeza@changemtg.com",
  "chm_ldevries@changemtg.com",
  "chm_ltran@changemtg.com",
  "chm_lfazio@changemtg.com",
  "chm_mroque@changemtg.com",
  "chm_mgrigoryan@changemtg.com",
  "chm_mpennel@changemtg.com",
  "chm_mtrinh@changemtg.com",
  "chm_msnyder@changemtg.com",
  "chm_mmirza@changemtg.com",
  "chm_ncabrera@changemtg.com",
  "chm_ngarcia@changemtg.com",
  "chm_nciriza@changemtg.com",
  "chm_ngoade@changemtg.com",
  "chm_ngiron@changemtg.com",
  "chm_oduron@changemtg.com",
  "chm_pibarra@changemtg.com",
  "chm_pbarreras@changemtg.com",
  "chm_pguerra@changemtg.com",
  "chm_pseverino@changemtg.com",
  "chm_prosato@changemtg.com",
  "chm_pfrutig@changemtg.com",
  "chm_rmendoza@changemtg.com",
  "chm_rcossano@changemtg.com",
  "chm_rolson@changemtg.com",
  "chm_rcarmichael@changemtg.com",
  "chm_racosta@changemtg.com",
  "chm_rfilkins@changemtg.com",
  "chm_rrivas@changemtg.com",
  "chm_ssalcedo@changemtg.com",
  "chm_swickersham@changemtg.com",
  "chm_ssanchez@changemtg.com",
  "chm_strout@changemtg.com",
  "chm_saugustus@changemtg.com",
  "chm_smurphy@changemtg.com",
  "chm_skates@changemtg.com",
  "chm_spumo@changemtg.com",
  "chm_tjacobo@changemtg.com",
  "chm_tchen@changemtg.com",
  "chm_tseabold@changemtg.com",
  "chm_toddj@changemtg.com",
  "chm_tcannon@changemtg.com",
  "chm_vcarlo@changemtg.com",
  "chm_vmendoza@changemtg.com",
  "chm_vanessa@changemtg.com",
  "chm_vacosta@changemtg.com",
  "chm_whill@changemtg.com",
  "chm_zmclean@changemtg.com",
];

export const secondBatchWholesaleUsers = [
  //"chm_joe.mills@changewholesale.com", Usuario viejo
  //"chm_lklure@changemtg.com", Told us they should have special privileges
  "chm_rdoumani@changemtg.com",
  //"chm_mboladian@changemtg.com", Told us they should be in retail
  "chm_xmejorado@changemtg.com",
  "chm_bdavis@changemtg.com",
];

export const wholesaleUsers = [
  "chm_nima.fariman@changewholesale.com",
  "chm_naz.mehdizadeh@changewholesale.com",
  "chm_cmobasser_whs@changewholesale.com",
  "chm_tan.karim@changewholesale.com",
  "chm_russell.rothstein@changewholesale.com",
  "chm_mike.czartoryski@changewholesale.com",
  "chm_mike.leusner@changewholesale.com",
  "chm_sam.ashton@changewholesale.com",
  "chm_chris.kavoosi@changewholesale.com",
  "chm_connie.foyle@changewholesale.com",
  "chm_carlos.cabezas@changewholesale.com",
  "chm_ben.burger@changewholesale.com",
  "chm_john.tvelia@changewholesale.com",
  "chm_joe.arici@changewholesale.com",
  "chm_mark.leusner@changewholesale.com",
  "chm_joe.marougi@changewholesale.com",
  "chm_deon.ward@changewholesale.com",
  "chm_stan.spencer@changewholesale.com",
  "chm_ciro.dipalma@changewholesale.com",
  "chm_khaled.trabulsi@changewholesale.com",
  "chm_stuart.lebowitz@changewholesale.com",
  "chm_cole.eby@changewholesale.com",
  "chm_clark.knoblock@changewholesale.com",
  "chm_davis.hill@changewholesale.com",
  "chm_marilyn.pena@changewholesale.com",
  "chm_jaylene.torres@changewholesale.com",
  "chm_rose.park@changewholesale.com",
  "chm_christopher.heston@changewholesale.com",
  "chm_nyree.derderian@changewholesale.com",
  "chm_monika.sanchez@changewholesale.com",
  "chm_alexis.kelley@changewholesale.com",
  "chm_amy.draper@changewholesale.com",
  "chm_steele.twiford@changewholesale.com",
  "chm_syssi.palomera@changewholesale.com",
  "chm_justin.pratt@changewholesale.com",
  "chm_cesar.ramirez@changewholesale.com",
  "chm_hilario.cruz@changewholesale.com",
  "chm_timothy.metzer@changewholesale.com",
  "chm_ronald.ineman@changewholesale.com",
  "chm_justin.hurley@changewholesale.com",
  "chm_gvaldellon@changemtg.com",
  "chm_toni.campbell@changewholesale.com",
  //"chm_lklure@changemtg.com", she was told to have special privileges
  "chm_cristina.arroyo@changewholesale.com",
  "chm_jbrown@changemtg.com",
  "chm_cmcginley@changemtg.com",
  ...secondBatchWholesaleUsers,
];

export const lklure = ["chm_lklure@changemtg.com"];

export const mboladian = ["chm_mboladian@changemtg.com"];

export const retailUsers = [
  //"chm_rmontes@changemtg.com", old user
  "chm_nsharp@changemtg.com",
  "chm_bunker@changemtg.com",
  "chm_abrown@changemtg.com",
  "chm_manderson@changemtg.com",
  "chm_cdickie@changemtg.com",
  "chm_nmcgraw@changemtg.com",
  //"chm_ddempster@changemtg.com", old user
  "chm_llin@changemtg.com",
  "chm_llinn@changemtg.com",
  "chm_ski@changemtg.com",
  //"chm_nkreager@changemtg.com", old user
  "chm_sbemis@changemtg.com",
  "chm_pguerrera@changemtg.com",
  "chm_avillareal@changemtg.com",
  "chm_nmuluneh@changemtg.com",
  "chm_sdeleon@changemtg.com",
  //"chm_mboladian@changemtg.com",
];

export const secondRetailUsers = [
  "chm_bcrowder@changemtg.com",
  "chm_calvin@changemtg.com",
  "chm_jbonner@changemtg.com",
  "chm_llinn@changemtg.com",
];

export const onlyAEPerformanceScoreboardUser = [
  "chm_amy.lazar@changewholesale.com", 
  "chm_caroline.collins@changewholesale.com",
  "chm_glen.pizzolorusso@changewholesale.com",
  "chm_ryan.moore@changewholesale.com",
  "chm_tina.burke@changewholesale.com", 
  "chm_alison.wapato@changewholesale.com",
];

export const CambioLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        { title: "Search", description: "", link: "answer" },
        { title: "Liveboards", description: "", link: "pinboards/" },
        {
          title: "Other Liveboards",
          description: "",
          link: `/${subDomain}/other`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...secondRetailUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
      ],
      [
        {
          title: "Retail Channel Summary",
          description: "",
          link: "pinboard/858d8b5b-3db8-4a5f-bcea-cdf06c05cca0",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...lklure,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Retail Channel Summary v2",
          description: "",
          link: "pinboard/67eba66c-e1f6-4b3e-990d-0c624873b1e3",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...lklure,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Branch Performance Summary",
          description: "",
          link: `/${subDomain}/branchesperformancesummary`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser],
        },
        {
          title: "Branch Performance Scoreboard",
          description: "",
          link: `/${subDomain}/branchesscoreboard`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser],
        },
        {
          title: "LO Performance Summary",
          description: "",
          link: `/${subDomain}/loperformancesummary`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser],
        },
        {
          title: "LO Performance Scoreboard",
          description: "",
          link: `/${subDomain}/loscoreboard`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser],
        },
      ],
      [
        {
          title: "Wholesale Ranking",
          description: "",
          link: "pinboard/5b856bf6-e181-4854-81bf-d3ae60362070",
          hideForTheseUsers: [
            ...retailUsers,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Wholesale Channel Summary",
          description: "",
          link: "pinboard/afd42ebe-656c-4796-832f-4a68b2d5bc28",
          hideForTheseUsers: [
            ...retailUsers,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "AE Performance Summary",
          description: "",
          link: `/${subDomain}/aeperformancesummary`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...secondRetailUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser],
        },
        {
          title: "AE Performance Scoreboard",
          description: "",
          link: `/${subDomain}/aescoreboard`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [...secondRetailUsers, ...loanOfficerUsers],
        },
        {
          title: "Wholesale Executive Dashboard",
          description: "",
          link: `/${subDomain}/wholesalesale`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Retail Executive Dashboard",
          description: "",
          link: `/${subDomain}/retail`,
          internal: true,
          overrideParentURL: true,
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser  
          ],
        },
      ],
      [
        {
          title: "Lock Summary",
          description: "",
          link: "pinboard/373e550b-85b2-4531-9f12-938e069efbdd",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Lock Report Month to Date",
          description: "",
          link: "pinboard/4d398d38-0467-4e18-8e38-8ee170fbfa8e",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Daily Average Volume by Month",
          description: "",
          link: "pinboard/dfe579f9-cfb0-4371-95a0-b1ec3568939b",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
        {
          title: "Daily Lock Report",
          description: "",
          link: "pinboard/04949638-d30c-4528-9167-e7dc94a0040a",
          hideForTheseUsers: [
            ...wholesaleUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ],
        },
      ],
    ]}
  />
);

export const CambioOtherLandingPage = (
  <TSLandingPage
    smallButtons={false}
    parentURL={`/${subDomain}/product`}
    buttons={[
      [
        {
          title: "Go Back",
          description: "",
          link: `/${subDomain}`,
          internal: true,
          overrideParentURL: true,
        },
      ],
      [
        {
          title: "Retail Region",
          description: "",
          link: "pinboard/c08ef7be-fffe-4f9f-9ba2-712ce22c1e68",
        },
        {
          title: "Retail Branch",
          description: "",
          link: "pinboard/963ac30c-233f-4a6b-84ab-6fa63f76d83a",
        },
        {
          title: "Retail LO",
          description: "",
          link: "pinboard/803e939d-6381-45ae-90f6-6706ac66cd9a",
        },
      ],
      [
        {
          title: "Originations Snapshot",
          description: "",
          link: "pinboard/e7219ea4-c11e-472b-a072-aafef848ab64",
        },
        {
          title: "Fulfillment Productivity",
          description: "",
          link: "pinboard/b53cb3b0-f03d-4d08-b145-6259aae5279e",
        },
      ],
      [
        {
          title: "Wholesale Region",
          description: "",
          link: "pinboard/6cf561fd-d685-44cc-b20d-f718903e091e",
        },
        {
          title: "Wholesale AE",
          description: "",
          link: "pinboard/39bd4c30-2495-4581-9d3a-9de4138bb6a6",
        },
        {
          title: "Wholesale Broker",
          description: "",
          link: "pinboard/b831d1cb-26f9-42c6-b2c2-6102be2f2ba8",
        },
      ],
      [
        {
          title: "Pipeline Overview",
          description: "",
          link: "pinboard/cef8c0f9-9398-49c8-a0ea-e65edffbfb59",
        },
        {
          title: "Originations Summary",
          description: "",
          link: "pinboard/916c0c86-21f8-4287-8876-09586ce68297",
        },
      ],
    ]}
  />
);

export const chmRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={
        <GenerateSidebar
          productTitle="CHM"
          subDomainURL={subDomain}
          generateViaHardcodedData={true}
        />
      }
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={CambioLandingPage}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/other`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={CambioOtherLandingPage}
          groups={secureRouteGroups}
          forbiddenUsernames={[
            ...wholesaleUsers,
            ...retailUsers,
            ...lklure,
            ...mboladian,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ]}
        />
      ),
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              orgObject={chmObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}product`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/aeperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Account Executive" />}
          groups={secureRouteGroups}
          forbiddenUsernames={[...secondRetailUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser]}
        />
      ),
    },
    {
      path: `/${subDomain}/aescoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics
              addTotalsToCSV={true}
              scope="Account Executive"
            />
          }
          groups={secureRouteGroups}
          forbiddenUsernames={[...secondRetailUsers, ...loanOfficerUsers,]}
        />
      ),
    },
    {
      path: `/${subDomain}/branchesperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Branches" />}
          groups={secureRouteGroups}
          forbiddenUsernames={[...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser]}
        />
      ),
    },
    {
      path: `/${subDomain}/branchesscoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics addTotalsToCSV={true} scope="Branches" />
          }
          groups={secureRouteGroups}
          forbiddenUsernames={[...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser]}
        />
      ),
    },
    {
      path: `/${subDomain}/loperformancesummary`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<HeatmapPerformanceMetrics scope="Loan Officers" />}
          groups={secureRouteGroups}
          forbiddenUsernames={[...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser]}
        />
      ),
    },
    {
      path: `/${subDomain}/loscoreboard`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <TablePerformanceMetrics
              addTotalsToCSV={true}
              scope="Loan Officers"
            />
          }
          groups={secureRouteGroups}
          forbiddenUsernames={[...wholesaleUsers, ...loanOfficerUsers, ...onlyAEPerformanceScoreboardUser]}
        />
      ),
    },
    {
      path: `/${subDomain}/wholesalesale`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <FullScreenPerformanceMetrics
              scope="Wholesale"
              overrideTitle="Wholesale Executive Dashboard"
            />
          }
          groups={secureRouteGroups}
          forbiddenUsernames={[
            ...wholesaleUsers,
            ...retailUsers,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ]}
        />
      ),
    },
    {
      path: `/${subDomain}/retail`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <FullScreenPerformanceMetrics
              scope="Retail"
              overrideTitle="Retail Executive Dashboard"
            />
          }
          groups={secureRouteGroups}
          forbiddenUsernames={[
            ...wholesaleUsers,
            ...retailUsers,
            ...mboladian,
            ...secondRetailUsers,
            ...loanOfficerUsers,
            ...onlyAEPerformanceScoreboardUser
          ]}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};

